<template>
  <footer class="footer px-4">
    <div class="row align-items-center justify-content-lg-between">
      <div class="col-lg-6">
        <div class="copyright text-center text-lg-left text-muted">
          © {{year}} <a href="#" class="font-weight-bold ml-1">{{churchDetail.ChurchName}}</a>
        </div>
      </div>
      <div class="col-lg-6">
        <ul class="nav nav-footer justify-content-center justify-content-lg-end">    
         <li class="nav-item">
            <a href="#" class="nav-link" target="_blank">FAQ</a>
          </li>        
                
          <li class="nav-item">
            <a href="#" class="nav-link" target="_blank">Privacy</a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  },
   computed: {
        ...mapState({
            churchDetail: state => state.church.churchDetail
        })
    },
};
</script>
<style></style>
